import { createContext, useContext } from 'react'

import type { PageGraphSource } from './canvasTypes'

export type NodeFocusRequest = { pageId: string; nodeId: string }

export type PendingNodeFocus = {
  request: NodeFocusRequest
  onHandled: () => void
}

type NodeFocusStep = 'wait' | 'drop' | 'focus'

export function nodeFocusStep(
  { pageId, nodeId }: NodeFocusRequest,
  pageGraphs: PageGraphSource[]
): NodeFocusStep {
  const page = pageGraphs.find(({ graph }) => graph.pageId === pageId)
  if (!page) return 'wait'
  return page.graph.getNode(nodeId) ? 'focus' : 'drop'
}

const NodeFocusRequestContext = createContext<PendingNodeFocus | undefined>(
  undefined
)

export const NodeFocusRequestProvider = NodeFocusRequestContext.Provider

export const usePendingNodeFocus = (): PendingNodeFocus | undefined =>
  useContext(NodeFocusRequestContext)
